import React from 'react';
import FormWrapper from '../../../BaseModule/Components/Form/FormWrapper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import useTranslation from '../../../../Hooks/useTranslation';
import SubmitButton from '../../../BaseModule/Components/Button/SubmitButton';
import { joinClasses } from '../../../../Utils/className.util';
import Text from '../../../BaseModule/Components/Text';
// @ts-ignore
import styles from './UserWalletDeposit.module.scss';
import FormattedPriceInputField
	from '../../../BaseModule/Components/Inputs/FormattedPriceInput/FormattedPriceInputField';
import { useInputValidation } from '../../../BaseModule/Hooks/useInputValidation';
import apiClient from '../../../../Services/ApiClient';
import useApiClient from '../../../../Hooks/useApiClient';

const UserWalletDeposit: React.FC = ({}) => {
	const { t } = useTranslation();
	const { getPriceInputValidation } = useInputValidation();
	const { displayError } = useApiClient();

	const validationSchema = yup.object({
		amount: getPriceInputValidation({ inputName: t('component.userWalletDeposit.validationMessage') ?? '', minimalValue: 300 }),
	});

	const formMethods = useForm({
		defaultValues: {},
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (values: any) => {
		try {
			const response = await apiClient.post('/meddi-credits', {
				name: t('component.userWalletDeposit.orderItemName'),
				price: {
					pricePieceWithVat: 1,
					vatRate: 21,
					currency: 'CZK',
					quantity: parseInt(values?.amount),
				},
			});

			if (response?.data?.redirectUrl) {
				// @ts-ignore
				window.location.href = response.data.redirectUrl;
			}

		} catch (e) {
			displayError(e);
		}
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<FormattedPriceInputField name='amount' label='component.userWalletDeposit.form.amount' isRequired />
			<Text tx='component.userWalletDeposit.form.hint' className={styles.hint} />
			<SubmitButton
				onSubmit={handleSubmit}
				className={joinClasses(['btn btn-primary w-100 mt-3'])}
				title='component.userWalletDeposit.form.buy'
			/>
		</FormWrapper>
	);
};

export default UserWalletDeposit;

